import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';

import OptionsButton from 'common/components/options-button';
import DeleteButton from 'common/components/delete-button';

@inject('genreStore')
@observer
class GenreOptions extends React.Component {
	render () {
		const { genreID, genreStore } = this.props;

		return (
			<OptionsButton onClick={ this.onClick }>
				{
					genreID === genreStore.activeGenreRowID ?
						this.renderOptions() : null
				}
			</OptionsButton>
		);
	}

	renderOptions () {
		return (
			<div className="cell auto list-options-menu">
				<button
					onClick={ this.onEditClick }
					className="button secondary clear margin-bottom-0">
						<span className="fas fa-pencil"></span> Edit Genre
				</button>

				<DeleteButton
					warningText="Really delete this genre?"
					onDeleteClick={ this.onDeleteClick }
					onConfirmClick={ this.onConfirmClick }
					onCancelClick={ this.onCancelClick }>
						<button className="button secondary clear margin-bottom-0">
							<span className="fas fa-trash"></span> Remove Genre
						</button>
				</DeleteButton>
			</div>
		);
	}

	@autobind
	onClick (evt) {
		const { genreStore, genreID } = this.props;
		genreStore.setActiveGenreRowID(genreID);

		evt.stopPropagation();
	}

	@autobind
	onEditClick (evt) {
		const { genreStore, genreID } = this.props;
		genreStore.setEditGenreRowID(genreID);
		this.clearActiveGenre();

		evt.stopPropagation();
	}

	@autobind
	onDeleteClick () {

	}

	@autobind
	onConfirmClick () {
		const { genreStore, genreID } = this.props;

		genreStore.deleteItem({
			_id: genreID
		});

		this.clearActiveGenre();
	}

	@autobind
	onCancelClick () {
		this.clearActiveGenre();
	}

	clearActiveGenre () {
		this.props.genreStore.setActiveGenreRowID(null);
	}
}

export default GenreOptions;
